var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartSelectedRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4972",
    fillRule: "evenodd",
    d: "M9.988 1.849l1.027 2.041c.248.491.725.831 1.278.91l2.297.327c1.391.199 1.947 1.876.94 2.839l-1.662 1.589c-.4.382-.582.933-.488 1.472l.392 2.244c.238 1.359-1.217 2.396-2.461 1.755l-2.055-1.06a1.725 1.725 0 0 0-1.579 0l-2.054 1.06c-1.245.641-2.699-.396-2.462-1.755l.393-2.244a1.644 1.644 0 0 0-.488-1.472L1.404 7.966c-1.007-.963-.451-2.64.94-2.839L4.641 4.8a1.695 1.695 0 0 0 1.277-.91l1.027-2.041c.623-1.237 2.421-1.237 3.043 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartSelectedRed);
export default __webpack_public_path__ + "static/media/start-selected-red.166f5b53.svg";
export { ForwardRef as ReactComponent };